import { theme as defaultTheme } from "@mindlercare/ui-web";
import { PropsWithChildren } from "react";
import { styled, css } from "styled-components";
import { Typography } from "components/typography";

export const Container = styled.div<{
  isDurationOneHour: boolean;
  isCanceled: boolean;
  isSlotValidForPatientSelected: boolean;
}>`
  display: flex;
  margin: 0;
  padding: 0 0 0 6px;
  background-color: ${(props) => props.color};
  border-radius: 6px;
  border: 1px solid ${defaultTheme.COLORS.MIDDLE_GREY};
  align-items: flex-start;
  justify-content: flex-start;
  height: 100%;
  position: relative;

  ${({ isSlotValidForPatientSelected }) =>
    isSlotValidForPatientSelected &&
    css`
      :hover {
        border: 1px solid ${defaultTheme.COLORS.BLUE_DARK};
      }
    `}

  svg {
    flex: 0 0 10px;
    pointer-events: none;
  }

  ${({ isCanceled }) =>
    isCanceled &&
    css`
      text-decoration: line-through;
      text-decoration-color: ${defaultTheme.COLORS.BLACK};
    `}

  ${({ isDurationOneHour }) =>
    isDurationOneHour &&
    css`
      display: flex;
      flex-direction: column;
      align-items: flex-start;
    `}

    ${({ isDurationOneHour }) =>
    !isDurationOneHour &&
    css`
      align-items: center;
    `}
`;

export const StatusText = styled(Typography)`
  padding: 0;
  margin: 0;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
`;

export const HoverStatusWrapper = styled.div`
  position: absolute;
  top: -36px;
  left: 0;
  right: 0;
  margin: 0 auto;
  display: flex;
  width: 100%;
  z-index: 1000;
  white-space: nowrap;
`;

export const HoverStatusBg = styled.div`
  background: ${defaultTheme.COLORS.GRAY_DARK};
  padding: 8px;
  border-radius: 4px;
  font-size: ${defaultTheme.FONT.SIZE.SMALL};
  color: ${defaultTheme.COLORS.WHITE};
`;

export const TimeContainer = styled.div<{ isDurationOneHour: boolean }>`
  ${({ isDurationOneHour }) =>
    !isDurationOneHour &&
    css`
      flex: 0 0 auto;
    `}
  display: flex;
  align-items: center;
  margin-right: 4px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  max-width: 100%;
`;

export const HoverStatus = (props: PropsWithChildren<unknown>) => {
  return (
    <HoverStatusWrapper {...props}>
      <HoverStatusBg>{props?.children}</HoverStatusBg>
    </HoverStatusWrapper>
  );
};
